"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _togaTheme = require("@thinkific/toga-theme");

var _buttonVariations = require("./buttonVariations");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  // Border radius\n  ", "\n\n  // Text transform\n  ", "\n\n  // Font weight\n  ", "\n\n  // Button variations\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var appearanceStyles = {
  primary: _buttonVariations.solidButton,
  secondary: _buttonVariations.outlineButton,
  knockout: _buttonVariations.knockoutButton,
  link: _buttonVariations.linkButton,
  'accessible-link': _buttonVariations.linkButton
};

var getButtonColor = function getButtonColor(_ref) {
  var color = _ref.color,
      hasDanger = _ref.hasDanger,
      isUpgrade = _ref.isUpgrade,
      isAlternate = _ref.isAlternate,
      theme = _ref.theme;

  if ((0, _togaTheme.isColor)(color)) {
    return color;
  }

  if (!(hasDanger || isUpgrade || isAlternate)) {
    var _theme$color;

    return (_theme$color = theme.color) === null || _theme$color === void 0 ? void 0 : _theme$color.primary;
  }

  if (hasDanger && !(isUpgrade || isAlternate)) {
    var _theme$color2;

    return (_theme$color2 = theme.color) === null || _theme$color2 === void 0 ? void 0 : _theme$color2.danger;
  }

  if (isUpgrade || isAlternate) {
    var _theme$color3;

    return (_theme$color3 = theme.color) === null || _theme$color3 === void 0 ? void 0 : _theme$color3.secondary;
  }

  return null;
};

var buttonCSS = (0, _styledComponents.css)(_templateObject(), function (props) {
  var _props$theme, _props$theme$button, _props$theme2, _props$theme2$button;

  return (((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$button = _props$theme.button) === null || _props$theme$button === void 0 ? void 0 : _props$theme$button.borderRadius) || ((_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : (_props$theme2$button = _props$theme2.button) === null || _props$theme2$button === void 0 ? void 0 : _props$theme2$button.borderRadius) === 0) && "\n    border-radius: ".concat(props.theme.button.borderRadius, "px;\n  ");
}, function (props) {
  var _props$theme3, _props$theme3$button;

  return ((_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : (_props$theme3$button = _props$theme3.button) === null || _props$theme3$button === void 0 ? void 0 : _props$theme3$button.allCaps) === false && "\n    text-transform: none;\n  ";
}, function (props) {
  var _props$theme4, _props$theme4$button;

  return ((_props$theme4 = props.theme) === null || _props$theme4 === void 0 ? void 0 : (_props$theme4$button = _props$theme4.button) === null || _props$theme4$button === void 0 ? void 0 : _props$theme4$button.fontWeight) && "\n    font-weight: ".concat(props.theme.button.fontWeight, ";\n  ");
}, function (props) {
  return appearanceStyles[props.appearance] && getButtonColor(props) && "\n  ".concat(appearanceStyles[props.appearance](getButtonColor(props)));
});
var _default = buttonCSS;
exports["default"] = _default;